var _defs, _path, _path2, _rect, _rect2, _path3, _path4, _path5, _rect3, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPassword(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ART",
    width: 32,
    height: 40,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:url(#linear-gradient-3);}.cls-4{fill:url(#linear-gradient-4);}.cls-5{fill:url(#linear-gradient-5);}.cls-6{fill:url(#linear-gradient-6);}.cls-7{fill:url(#linear-gradient-7);}.cls-8{fill:url(#linear-gradient-8);}.cls-9{fill:url(#linear-gradient-9);}.cls-10{fill:url(#linear-gradient-10);}.cls-11{fill:url(#linear-gradient-11);}.cls-12{fill:url(#linear-gradient-12);}.cls-13{fill:url(#linear-gradient-13);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 24,
    y1: 30.25,
    x2: 24,
    y2: -4.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#cce2e6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8fa1bb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 24,
    y1: 11.44,
    x2: 24,
    y2: 24.03,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 24,
    y1: 78.83,
    x2: 24,
    y2: 14.26,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#27e9de"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#03a4ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2547a8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    y1: 51.31,
    x2: 24,
    y2: 37.23,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    y1: 11.75,
    x2: 24,
    y2: 28.7,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    y1: 46.55,
    x2: 24,
    y2: 24.04,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    y1: 36.75,
    x2: 24,
    y2: 26.33,
    xlinkHref: "#linear-gradient-3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 24,
    y1: 44.33,
    x2: 24,
    y2: 13.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#273a9b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#202f65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#021e2f"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 9,
    y1: 37.75,
    x2: 9,
    y2: 20.85,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f3c57a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#f39369"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e94867"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 16.5,
    y1: 36.83,
    x2: 16.5,
    y2: 25.29,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 24,
    y1: 36.83,
    x2: 24,
    y2: 25.29,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 31.5,
    y1: 36.83,
    x2: 31.5,
    y2: 25.29,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 39,
    y1: 36.83,
    x2: 39,
    y2: 25.29,
    xlinkHref: "#linear-gradient"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "passwork, lock, pin, privacy, safety") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36,31.71H12V15A12,12,0,1,1,36,15ZM16.82,26.92H31.18V15a7.18,7.18,0,1,0-14.35,0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M36,18.19a3.46,3.46,0,0,0-1.1-.19H31.18v9.57H16.82V18H13.14a3.46,3.46,0,0,0-1.1.19V32.35H36Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 9,
    y: 21,
    width: 30,
    height: 24,
    rx: 3.89,
    ry: 3.89
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 9,
    y: 28.5,
    width: 30,
    height: 12
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M12.89,21a3.88,3.88,0,0,0-3.68,2.67H38.78A3.88,3.88,0,0,0,35.11,21Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M27.24,31.74A3.24,3.24,0,0,0,20.85,31a3.21,3.21,0,0,0,.63,2.81,1.72,1.72,0,0,1,.36,1.09v.48A2.16,2.16,0,0,0,24,37.5h0a2.16,2.16,0,0,0,2.16-2.16v-.48a1.78,1.78,0,0,1,.37-1.11A3.19,3.19,0,0,0,27.24,31.74Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M27,32.88a3.23,3.23,0,0,0-3.88-2,3.2,3.2,0,0,0-2.16,2,3.24,3.24,0,0,0,.5.9,1.72,1.72,0,0,1,.36,1.09v.48a2.16,2.16,0,1,0,4.32,0v-.48a1.78,1.78,0,0,1,.37-1.11A3.24,3.24,0,0,0,27,32.88Z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 3,
    y: 27,
    width: 42,
    height: 12,
    rx: 2.6,
    ry: 2.6
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M10.67,33.1,10.5,33l.17-.1a.75.75,0,0,0-.75-1.3l-.17.1v-.2a.75.75,0,0,0-1.5,0v.2l-.17-.1a.75.75,0,1,0-.75,1.3l.17.1-.17.1a.75.75,0,1,0,.75,1.3l.17-.1v.2a.75.75,0,0,0,1.5,0v-.2l.17.1a.75.75,0,0,0,.75-1.3Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M18.17,33.1,18,33l.17-.1a.75.75,0,0,0-.75-1.3l-.17.1v-.2a.75.75,0,0,0-1.5,0v.2l-.17-.1a.75.75,0,1,0-.75,1.3L15,33l-.17.1a.75.75,0,1,0,.75,1.3l.17-.1v.2a.75.75,0,0,0,1.5,0v-.2l.17.1a.75.75,0,0,0,.75-1.3Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M25.67,33.1,25.5,33l.17-.1a.75.75,0,0,0-.75-1.3l-.17.1v-.2a.75.75,0,0,0-1.5,0v.2l-.17-.1a.75.75,0,1,0-.75,1.3l.17.1-.17.1a.75.75,0,1,0,.75,1.3l.17-.1v.2a.75.75,0,0,0,1.5,0v-.2l.17.1a.75.75,0,0,0,.75-1.3Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M33.17,33.1,33,33l.17-.1a.75.75,0,0,0-.75-1.3l-.17.1v-.2a.75.75,0,0,0-1.5,0v.2l-.17-.1a.75.75,0,1,0-.75,1.3L30,33l-.17.1a.75.75,0,1,0,.75,1.3l.17-.1v.2a.75.75,0,0,0,1.5,0v-.2l.17.1a.75.75,0,0,0,.75-1.3Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M40.67,33.1,40.5,33l.17-.1a.75.75,0,0,0-.75-1.3l-.17.1v-.2a.75.75,0,0,0-1.5,0v.2l-.17-.1a.75.75,0,1,0-.75,1.3l.17.1-.17.1a.75.75,0,1,0,.75,1.3l.17-.1v.2a.75.75,0,0,0,1.5,0v-.2l.17.1a.75.75,0,0,0,.75-1.3Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/password.dbe4cbb8c5bb6d451cc5001bd0ca6eca.svg";
export { ForwardRef as ReactComponent };